import type { BoxProps } from '@mui/material';
import { Box, styled } from '@mui/material';

export const ContentWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(3),
  paddingTop: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  minHeight: 'calc(100dvh - 8rem)',
  overflowX: 'clip',
  [theme.breakpoints.up('sm')]: {
    paddingBottom: theme.spacing(2),
  },
}));
